import { render } from "./OrderProfitSumByClosedDate.vue?vue&type=template&id=517c2081"
import script from "./OrderProfitSumByClosedDate.vue?vue&type=script&lang=js"
export * from "./OrderProfitSumByClosedDate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__